import React, {useState} from "react";
import CustomCheckBox from "./CustomCheckBox";
import CustomInput from "./CustomInput";
import CustomRadioBox, { IRadioOption } from "./CustomRadioBox";


function Dialog() {
    const options: IRadioOption[] = [
        { value: "red" , label: "Rot" },
        { value: "green", label: "Grün" },
        { value: "blue" , label: "Blau" },
    ];
    const [state, setInputValue] = useState({name: "", vorname: "", password: "", good: false, selectedIndex: 0});

    return (
        <div className="page">
            <div className="dialog">
                <fieldset>
                    <legend>Persönliche Daten</legend>
                    <CustomInput
                        tabIndex={1}
                        className={"login_input"}
                        value={state.vorname}
                        label={"Vorname"}
                        placeholder={"Max"}
                        setState={(value: string) => setInputValue({...state, vorname: value})}
                        // readOnly={true}
                        // disabled={true}
                    />
                    <CustomInput
                        tabIndex={2}
                        className={"login_input"}
                        value={state.name}
                        label={"Name"}
                        placeholder={"Mustermann"}
                        setState={(value: string) => setInputValue({...state, name: value})}
                        // autoComplete={"test-name"}
                    />
                    <CustomInput
                        tabIndex={3}
                        className={"login_input"}
                        value={state.password}
                        type="password"
                        eye={true}
                        label={"Passwort"}
                        setState={(value: string) => setInputValue({...state, password: value})}
                        // autoComplete={"test-name"}
                    />
                    <CustomCheckBox
                        tabIndex={4}
                        className=""
                        label="Gut"
                        value={state.good}
                        switch={(value: boolean) =>  setInputValue({...state, good: value})}
                    />
                    <CustomRadioBox
                        options={options}
                        selectedIndex={state.selectedIndex}
                        switch = {(selectedIndex: number) => setInputValue({...state, selectedIndex})}
                    />
                </fieldset>
            </div>
            <div className="dialog">
                <fieldset>
                    <legend>Kontrolle</legend>
                    <CustomInput
                        className={"login_input"}
                        value={state.vorname}
                        label={"Vorname"}
                        disabled={true}
                    />
                    <CustomInput
                        className={"login_input"}
                        value={state.name}
                        label={"Name"}
                        disabled={true}
                    />
                    <CustomInput
                        className={"login_input"}
                        value={state.password}
                        type="password"
                        label={"Passwort"}
                        disabled={true}
                    />
                    <CustomCheckBox
                        className=""
                        label="Gut"
                        value={state.good}
                    />
                    <CustomInput
                        className={"login_input"}
                        value={options[state.selectedIndex].label + "(" + options[state.selectedIndex].value + ")"}
                        label={"Farbe"}
                    />
                </fieldset>
            </div>
            <div className="clear"/>
        </div>
    );
}

export default (Dialog);
